import "./CardGrid.css";
import card_front from './backgrounds/card_front.png';
import ProductionCard from "./card_content/card_content.component.jsx";
import img_15days_free from './card_content/svgs/free_15_days.svg';
import img_daily_practice from './card_content/svgs/daily_practice.svg';
import img_expert_view from './card_content/svgs/expert_view.svg';
import img_no_extra_app from './card_content/svgs/no_extra_app.svg';
import img_personalised from './card_content/svgs/personalised.svg';
import img_balanced_svg from './card_content/svgs/balanced.svg';
import img_step_by_step from './card_content/svgs/step_by_step.svg';
import img_be_prepared from './card_content/svgs/be_prepared.svg';

const cards = [
    {
        id: 1, content: {
            label: 'GET STARTED',
            titleBold: '15 days free access and ',
            titleLight: 'discover at no cost',
            image: img_15days_free
        }
    },
    {
        id: 2, content: {
            label: 'DAILY PRACTICE',
            titleBold: '5 minutes everyday',
            titleLight: 'practice at your convenience',
            image: img_daily_practice
        }
    },
    {
        id: 3, content: {
            label: 'EXPERT INSIGHT',
            titleBold: 'Designed and Curated ',
            titleLight: 'by industry architects',
            image: img_expert_view
        }
    },
    {
        id: 4, content: {
            label: 'PERSONALIZED',
            titleBold: 'Content designed ',
            titleLight: 'for your experience',
            image: img_personalised
        }
    },
    {
        id: 5, content: {
            label: 'BALANCED',
            titleBold: 'Easy to hard questions ',
            titleLight: 'mixed for steady growth',
            image: img_balanced_svg
        }
    },
    {
        id: 6, content: {
            label: 'STEP BY STEP',
            titleBold: 'Questions answered ',
            titleLight: 'with full explanations',
            image: img_step_by_step
        }
    },

    {
        id: 7, content: {
            label: 'NO EXTRA APP',
            titleBold: 'Receive in whatsapp ',
            titleLight: 'answer anytime as you wish',
            image: img_no_extra_app
        }
    },
    {
        id: 8, content: {
            label: 'BE PREPARED',
            titleBold: 'Prepare confidently ',
            titleLight: 'one design question a day',
            image: img_be_prepared
        }
    }
];

export default function CardGrid() {
    return (
        <div className="card-grid">
            {cards.map((card) => (
                <div key={card.id} className="flip-card">
                    <div className="flip-card-inner">

                        {/* Front (closed card) */}
                        <div className="flip-card-front">
                            <img src={card_front} alt="Card Front" />
                        </div>

                        {/* Back (revealed card) */}
                        <div className="flip-card-back">
                            <ProductionCard content={card.content} />
                        </div>

                    </div>
                </div>
            ))}
        </div>
    );
}
